module.exports = __webpack_public_path__ + "static/q3answer1_cabin_wishmas-5ea4c59e74bce732fd759c49d1788fda.jpg";